<template>
  <div :class="{map: true, ipadpro }">
    <div class="mapSheet">
      <GmapMap
        :center="{lat:50.110924, lng:8.682127}"
        :zoom="13"
        :options="options"
        ref="map"
        style="width: 100%; height: 100%;"
      >
        <GmapMarker
          :key="'marker-' + index"
          v-for="(m, index) in markers"
          :position="m.position"
          :label="m.label"
          :icon="m.icon"
        />

        <GmapPolyline
          :key="'line-' + index"
          v-for="(l, index) in lines"
          :path="l.path"
          :options="{ strokeColor: l.strokeColor}"
        />
      </GmapMap>
    </div>
    <v-bottom-navigation>
      <v-btn class="autoHeight" :disabled="!table || firstElement" :loading="backLoading" @click="back">
        <span>Zurück</span>
        <v-icon>mdi-rewind</v-icon>
      </v-btn>

      <v-menu top offset-y>
        <template v-slot:activator="{ on }">
          <v-btn class="autoHeight" v-on="on">
            <span v-if="element">{{ moment(element.transceived_at).format('DD.MM.YYYY HH:mm') }}</span>
            <span v-else>Lade...</span>
            <v-icon>mdi-calendar-range</v-icon>
          </v-btn>
        </template>
        <div class="datepicker">
          <v-datetime-picker label="Zeige Werte vor diesem Datum" v-model="setDate" dateFormat="dd.MM.yyyy" timeFormat="HH:mm:ss" clearText="Abbrechen" okText="Übernehmen" :timePickerProps="timePickerProps">
            <v-icon slot="dateIcon">mdi-calendar</v-icon>
            <v-icon slot="timeIcon">mdi-clock</v-icon>
          </v-datetime-picker>

          <div class="d-flex flex-row justify-space-between">
            <v-btn color="primary" @click="commitDate">Übernehmen</v-btn>
            <v-btn @click="openDialog" align-end>Aus Liste wählen...</v-btn>
            <v-dialog v-model="dialog" scrollable max-width="300px">
              <v-card>
                <v-card-title>Wähle Messwert</v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px;" class="pt-3">
                  <v-btn :disabled="page <= 0" block color="primary" :class="{primary: page > 0}" @click="page--">Frühere Daten</v-btn>

                  <v-radio-group v-model="measurement" column>
                    <v-radio v-for="m in tablePage" :key="m.id" :label="moment(m.transceived_at).format('DD.MM.YYYY HH:mm:ss')" :value="m.id"></v-radio>
                  </v-radio-group>

                  <v-btn :disabled="!table || page + 1 > table.length / 100" block color="primary" :class="{primary: table && page + 1 <= table.length / 100}" @click="page++">Spätere Daten</v-btn>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn color="blue darken-1" text @click="dialog = false">Abbrechen</v-btn>
                  <v-btn color="blue darken-1" text @click="choose">Übernehmen</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            
          </div>
        </div>
      </v-menu>


      <v-btn class="autoHeight" :disabled="!table || live" @click="next">
        <span>Weiter</span>
        <v-icon>mdi-fast-forward</v-icon>
      </v-btn>

      <v-btn :color="live ? 'primary' : null" :class="{live, autoHeight: true}" value="live" @click="goLive">
        <span>Live Daten</span>
        <v-icon>mdi-history</v-icon>
      </v-btn>
    </v-bottom-navigation>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import fetchData from '@/mixins/fetchData.js';
import {gmapApi} from 'vue2-google-maps';
import moment from 'moment';

export default {
  name: 'Map',
  data() {
    return {
      moment,
      measurement: null,
      lastFrameCount: null,
      backLoading: false,
      nextLoading: false,
      dialog: false,
      page: 0,
      current: null,
      currentreading: null,
      firstElement: false,
      date: null,
      setDate: new Date(),
      live: true,
      markers: null,
      lines: null,
      toast: {
        position: 'bottom-right',
        theme: 'bubble',
        type: 'error',
        icon : {
          name : 'alert-circle-outline',
          after : false
        },
        duration: 3000
      },
      timePickerProps: {
        format: '24hr',
        'use-seconds': true
      },
      options: {
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true
      }
    };
  },
  mixins: [fetchData],
  methods: {
    openDialog() {
      this.live = false;
      this.measurement = this.current;
      window.setTimeout(() => {
        this.dialog = true;
      }, 401);
    },
    choose() {
      this.live = false;
      this.current = this.measurement;
      this.dialog = false;
    },
    async back() {
      this.live = false;

      if (this.index < this.table.length - 1) {
        if (this.table[this.index + 1].reading && this.table[this.index + 1].reading.id) {
           this.currentreading = this.table[this.index + 1].reading.id;
        } else {
          this.currentreading = null;
        }

        this.current = this.table[this.index + 1].id;
      } else {
        this.backLoading = true;

        let data = await this.fetchPage(this.current, this.currentreading);

        if (data.length > 0) {
          this.table = [...this.table, ...data];
          
          if (this.table[this.index + 1].reading && this.table[this.index + 1].reading.id) {
            this.currentreading = this.table[this.index + 1].reading.id;
          } else {
            this.currentreading = null;
          }

          this.current = this.table[this.index + 1].id;
        } else {
          this.firstElement = true;
        }

        this.backLoading = false;
      }
    },
    async next() {
      this.firstElement = false;
      this.live = false;

      if (this.index > 0) {
        if (this.table[this.index - 1].reading && this.table[this.index - 1].reading.id) {
           this.currentreading = this.table[this.index - 1].reading.id;
        } else{
          this.currentreading = null;
        }

        this.current = this.table[this.index - 1].id;
      } else {
        let data = await this.fetchPage(this.current, this.currentreading, 'ascending');

        if (data.length > 0) {
          this.table = [...data.reverse(), ...this.table];
          
          this.currentreading = this.table[this.index - 1].reading.id;
          this.current = this.table[this.index - 1].id;
        } else {
          this.live = true;
        }
      }
    },
    async goLive() {
      this.markers = null;
      this.lastFrameCount = null;
      this.table = null;
      this.lastFetch = null;
      this.after = null;
      this.date = null;

      if (this.timeout !== null) {
        window.clearTimeout(this.timeout);
      }

      await this.init();
      this.live = true;
      this.current = this.table[0].id;
      this.currentreading = this.table [0].reading.id;
    },
    async commitDate() {
      if (this.setDate) {
        this.markers = null;
        this.lastFrameCount = null;
        this.table = null;
        this.live = false;
        this.lastFetch = null;
        this.after = null;
        this.firstElement = false;

        if (this.timeout !== null) {
          window.clearTimeout(this.timeout);
        }
        
        let data1 = await this.fetchPage(null, null, 'descending', moment(this.setDate).toISOString());
        let data2 = await this.fetchPage(null, null, 'ascending', null, moment(this.setDate).toISOString());

        this.table = [...data2.reverse(), ...data1];

        let mostRecent = this.table.reduce((last, curr) => {
          if (last === null) {
            return curr;
          }
          let duration = moment.duration(moment(last.transceived_at).diff(moment(this.setDate)));
          let lastMinutes = Math.abs(duration.asSeconds());

          duration = moment.duration(moment(curr.transceived_at).diff(moment(this.setDate)));
          let currMinutes = Math.abs(duration.asSeconds());

          if (currMinutes < lastMinutes) {
            return curr;
          }

          return last;
        }, null);

        if (mostRecent) {
          this.current = mostRecent.id;
          this.currentreading = mostRecent.reading.id;
        }
      }
    }
  },
  watch: {
    live(live) {
      if (live) {
        if (this.timeout === null) {
          this.timeout = window.setInterval(this.init, 2000);
        }
      } else {
        if (this.timeout) {
          window.clearInterval(this.timeout);
          this.timeout = null;
        }
      }
    },
    table() {
      if (this.table === null) {
        this.live = false;
        this.current = null;
      } else if ((this.current === null || this.live) && this.table.length > 0) {
        this.current = this.table[0].id;
        if (this.table[0].reading) {
          this.currentreading = this.table[0].reading.id;
        } else {
          this.currentreading = null;
        }
      }
    },
    async element(element, old) {
      if (element !== null && old !== null && element.id === old.id) {
        return;
      }

      if (element === null) {
        return;
      }

      this.markers = null;
      this.lines = null;

      try {
        let markers = [];
        let lines = [];

        if (element && element.meta && element.meta.gateway_stats) {
          let gateways = element.meta.gateway_stats.map(e => this.gateways[e.router_id_hex]).filter(e => !!e);
          let frameCount = element.meta.frame_count_up;
          if (this.lastFrameCount !== null && this.lastFrameCount !== 1 && frameCount !== 1 && Math.abs(this.lastFrameCount - frameCount) > 1) {
            this.$toasted.show(`Verloren gegangene Pakete: ${Math.abs(this.lastFrameCount - frameCount) - 1}`, this.toast);
          }

          this.lastFrameCount = frameCount;

          gateways.forEach((e, i) => {
            if (e.location && e.location.coordinates) {
              markers.push({
                rssi: element.meta.gateway_stats[i].rssi,
                icon: {
                  url: require('@/assets/gateway.png'),
                  scaledSize: new this.google.maps.Size(32, 32),
                  labelOrigin: new this.google.maps.Point(16, 45)
                },
                label: e.name,
                position: {
                  lat: e.location.coordinates[1],
                  lng: e.location.coordinates[0]
                }
              });
            }
          });
        }
        let lastPosition = this.table.filter(e => e.reading && !!e.reading.location).reduce((last, curr) => {
          if (last === null) {
            return curr;
          }

          let durationLast = moment.duration(moment(last.transceived_at).diff(moment(element.transceived_at)));
          let lastSeconds = Math.abs(durationLast.asSeconds());

          let durationCurr = moment.duration(moment(curr.transceived_at).diff(moment(element.transceived_at)));
          let currSeconds = Math.abs(durationCurr.asSeconds());

          if (currSeconds < lastSeconds) {
            return curr;
          }

          return last;
        }, null);

        let sensor;

        let icon = {
          url: require('@/assets/lora.svg'),
          scaledSize: new this.google.maps.Size(45, 45),
          labelOrigin: new this.google.maps.Point(16, 55)
        };

        let iconNoGPS = {
          url: require('@/assets/lora_nogps.svg'),
          scaledSize: new this.google.maps.Size(45, 45),
          labelOrigin: new this.google.maps.Point(16, 55)
        };

        let name = this.deviceData ? this.deviceData.name : 'Sensor';

        if (element.reading && element.reading.location && element.reading.location.coordinates) {
          sensor = {
            icon,
            label: name,
            position: {
              lat: element.reading.location.coordinates[1],
              lng: element.reading.location.coordinates[0]
            }
          };
        } else if (this.deviceData.static_location && this.deviceData.location && this.deviceData.location.coordinates) {
          sensor = {
            icon,
            label: name,
            position: {
              lat: this.deviceData.location.coordinates[1],
              lng: this.deviceData.location.coordinates[0]
            }
          };
        } else if (!this.deviceData.static_location && lastPosition !== null) {
          sensor = {
            icon: iconNoGPS,
            label: name + ' (Letzte bekannte Position)',
            position: {
              lat: lastPosition.reading.location.coordinates[1],
              lng: lastPosition.reading.location.coordinates[0]
            }
          };
        } else if (!this.deviceData.static_location && this.deviceData.location && this.deviceData.location.coordinates) {
          sensor = {
            icon: iconNoGPS,
            label: name + ' (Letzte bekannte Position heute)',
            position: {
              lat: this.deviceData.location.coordinates[1],
              lng: this.deviceData.location.coordinates[0]
            }
          };
        } else if (markers.length === 1) {
          sensor = {
            icon: iconNoGPS,
            label: name + ' (Ohne Position)',
            position: {
              lat: markers[0].position.lat,
              lng: markers[0].position.lng + 0.005
            }
          };
        } else if (markers.length === 0) {
          sensor = {
            icon: iconNoGPS,
            label: name + ' (Ohne Position)',
            position: {
              lat: 50.110924,
              lng: 8.682127
            }
          };
        } else {
          sensor = {
            icon: iconNoGPS,
            label: name + ' (Ohne Position)',
            position: {
              lat: markers.reduce((last, curr) => last + curr.position.lat, 0) / markers.length,
              lng: markers.reduce((last, curr) => last + curr.position.lng, 0) / markers.length
            }
          };
        }

        markers.forEach(gateway => {
          let color;

          if (gateway.rssi > -90) {
            color = '#4CAF50';
          } else if (gateway.rssi > -105) {
            color = '#FFB74D';
          } else {
            color = '#F44336';
          }

          lines.push({
            path: [
              gateway.position,
              sensor.position
            ],
            strokeColor: color
          });

          markers.push({
            icon: {
              url: require('@/assets/lora.svg'),
              size: new this.google.maps.Size(0, 0),
            },
            label: `RSSI: ${gateway.rssi}`,
            position: {
              lat: (gateway.position.lat + sensor.position.lat) / 2,
              lng: (gateway.position.lng + sensor.position.lng) / 2 + 0.0001
            }
          });
        });

        markers.push(sensor);

        this.markers = markers;
        this.lines = lines;

        if (markers.length > 0) {
          const bounds = new this.google.maps.LatLngBounds();
          for (let m of markers) {
            bounds.extend(m.position);
          }
          this.$refs.map.fitBounds(bounds, 50);
        }
      } catch (e) {
        this.markers = [];
      }
    }
  },
  computed: {
    ipadpro() {
      var ratio = window.devicePixelRatio || 1;
      var screen = {
          width : window.screen.width * ratio,
          height : window.screen.height * ratio
      };
      
      return (screen.width === 1668 && screen.height === 2388) || (screen.width === 2388 && screen.height === 1668);
    },
    tablePage() {
      if (this.table && this.table.length > 0) {
        return this.table.filter((_, i) => {
          if (i < 100 * this.page + 100 && i >= 100 * this.page) {
            return true;
          }

          return false;
        });
      }
      
      return [];
    },
    google: gmapApi,
    overlay() {
      return this.markers === null;
    },
    device() {
      return this.$route.params.id;
    },
    element() {
      if (this.table && this.table.length > 0) {
        let filter = this.table.filter(e => e.id === this.current)[0];
        return filter ? filter : null;
      }

      return null;
    },
    index() {
      if (this.table && this.table.length > 0) {
        for (let i = 0; i < this.table.length; i++) {
          if (this.table[i].id === this.current) {
            return i;
          }
        } 
      }

      return -1;
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  width: 100%;
  height: 100%;
}

.mapSheet {
  width: 100%;
  height: calc(100% - 58px);
  position: relative;
}

.ipadpro .mapSheet {
  height: calc(100% - 80px);
}

.live * {
  color: white !important;
}

.datepicker {
  width: 100vw;
  max-width: 500px;
  height: 100vh;
  max-height: 150px;
  background-color: white;
  padding: 15px;
}

.autoHeight {
  height: auto !important;
}

</style>

<style lang="scss">
.toasted {
  font-family: Arial, Helvetica, sans-serif;
  
  i {
    font-size: 25px;
    position: relative;
    display: block;
    margin-top: 4px;
  }
} 
</style>